import lodash from "lodash";
import i18n from "../../../../i18n";
import { defineAsyncComponent } from "vue";
import { createLoading } from "../../../../utils/loading";
import { createManageExportCsv, createPage } from "../../../../utils/page";
import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber
} from "../../../../components/table/c-table.logic";

export const { isLoading, setIsLoading } = createLoading();

const Number = defineAsyncComponent(() => import("../../../../components/table/custom-render/Number"));

export const createColumns = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const item = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const items = [item];
    customItems2({ items });
    const columns = [];
    columns.push(
        createColumnInput({
            title: () => i18n.global.t("views.fee.inlineList.no"),
            dataIndex: "no",
            align: "center",
            width: 70,
            sorter: false,
        }),
        createColumnInput({
            title: () => i18n.global.t("views.fee.inlineList.desc"),
            dataIndex: "feeRateDocName",
            width: 300,
            sorter: false,
        }),
        createColumnInput({
            title: () => i18n.global.t("views.fee.inlineList.qty"),
            dataIndex: "qty",
            align: "center",
            width: 90,
            sorter: false,
        }),
        createColumnDate({
            title: () => i18n.global.t("views.fee.inlineList.dueDate"),
            dataIndex: "dueDate",
            align: "center",
            width: 100,
            sorter: false,
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.fee.inlineList.netAmount"),
            dataIndex: "netAmount",
            align: "right",
            width: 120,
            sorter: false,
            comma: true,
            allowPrecision: true,
            maxPrecision: 2,
            customRender: param => {
                return param.record.isColspan ? <b>{param.record.netAmount}</b> : <Number {...param.column} {...param}></Number>;
            }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.fee.inlineList.amount"),
            dataIndex: "amount",
            align: "right",
            width: 120,
            sorter: false,
            comma: true,
            allowPrecision: true,
            maxPrecision: 2,
            inputProp: () => ({ comma: true, allowPrecision: true, maxPrecision: 2 }),
        }),
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, itemsKey, } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const item = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const items = customItems({ item });
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [];
    data.rowActions = [];
};

const customItems = ({ item }) => {
    const items = [item];
    items.push({ isColspan: true, netAmount: i18n.global.t("views.fee.inlineList.total"), amount: item.netAmount });
    items.push({ isColspan: true, netAmount: i18n.global.t("views.fee.inlineList.netTotal"), amount: item.netAmount });
    return items;
}

const customItems2 = ({ items }) => {
    items.forEach((d, index) => {
        d.no = index+1;
        d.qty = 1;
        d.desc = `ค่าธรรมเนียมออก${d.refRequest?.refRequestDoc?.value || "ใบอนุญาต/ใบรับรอง"} เลขที่อ้างอิง (Ref.1) ${d.requestNumber1} / 1 ปี`;
        d.amount = d.netAmount
    });
}